module.exports = __webpack_public_path__ + "img/password_icon.76986bb7.svg";